// extracted by mini-css-extract-plugin
export default {"Container":"Tension_Container__EELe-","Choices":"Tension_Choices__qCErH","Choice":"Tension_Choice__bDNov"};